
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const MedicalHistorySection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const historyFields = [
    { name: "medicalHistory.relativesInfo", label: "child-patient-assessment.relatives-info", desc: "medicalHistory.relativesInfoDescription" },
    { name: "medicalHistory.geneticDiseases", label: "child-patient-assessment.genetic-diseases", desc: "medicalHistory.geneticDiseasesDescription" },
    { name: "medicalHistory.hereditaryDiseases", label: "child-patient-assessment.hereditary-diseases", desc: "medicalHistory.hereditaryDiseasesDescription" },
    { name: "medicalHistory.knownDiseases", label: "child-patient-assessment.known-diseases", desc: "medicalHistory.knownDiseasesDescription" },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid container spacing={2}>
        {historyFields.map((field) => (
          <Grid key={field.name} md={3} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(field.label)}>
              <Controller
                name={field.name}
                control={control}
                render={({ field: rbField }) => (
                  <ByzMuiRadioButton
                    {...rbField}
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                )}
              />
              <Controller
                name={field.desc}
                control={control}
                render={({ field: txtField }) => (
                  <ByzMuiTextField {...txtField} multiline rows={2} sx={{ pt: 1 }} />
                )}
              />
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
